export default __webpack_public_path__ + "static/media/avatar.99194741.svg";